import { useNavigate } from "react-router-dom";

import { Heritage } from "../components/Heritage";
import { usePersonalisationData } from "../context/PersonalisationDataContext";
import { usePersonalisationLeave } from "../context/PersonalisationLeaveContext";

import { ImproveConcernsContainer_PATH } from "./ImproveConcernsContainer";
import { SkinColorContainer_PATH } from "./SkinTypeContainer";

export const HeritageContainer_PATH = "/personalise/heritage" as const;

export function HeritageContainer() {
  const navigate = useNavigate();
  const { heritage, setHeritageAnswered, skipHeritage } =
    usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();
  return (
    <Heritage
      progressPercentage={34}
      initialSelectedId={heritage.state === "answered" ? heritage.value : null}
      onContinue={(selection) => {
        setHeritageAnswered(selection);
        navigate(SkinColorContainer_PATH);
      }}
      onSkip={() => {
        skipHeritage();
        navigate(SkinColorContainer_PATH);
      }}
      onBack={() => {
        navigate(ImproveConcernsContainer_PATH);
      }}
      onClose={openConfirmLeave}
    />
  );
}
